<template>
  <div class="session-eval-list">
    <my-certificates v-if="showCertList" />
    <my-certificates-link v-else />
    <template>
      <h2 class="vmx__evaluation-page__subheading">
        <b>{{ $t('VMX.evaluation_page_subheading') }}</b>
      </h2>
      <div class="session-eval__text-box">
      <div v-html="$t('VMX.evaluation_page_info_text_box', {userId})" />
    </div>
    <template v-if="showEvaluation && sessions && sessions.length > 0">
      <div class="vmx__evaluation-page__search">
        <b-form-group>
          <b-input-group>
            <b-form-input
              debounce="500"
              v-model="filter"
              :placeholder="$t('VMX.user_documents_filter_label_search')"
            />
            <b-input-group-append>
              <b-input-group-text
                @click="filter = null"
                style="cursor: pointer"
              >
                <b-icon icon="x" />
              </b-input-group-text>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </div>
      <div class="vmx__evaluation-page__sortBy">
        <div>
          <template v-if="filter && results">
            <span>
              <b>{{ results }}</b>
              {{ $t('VMX.evaluation_page_search_results') }}
            </span>
          </template>
        </div>
        <div class="session-eval__sort-by">
          <span class="session-eval__sort-by-text">
            {{ $t('VMX.evaluation_page_sort_by') }}
          </span>
          <b-form-select
            class="session-eval__sort-by-dropdown"
            v-model="sortSelected"
            :options="sortBy"
          />
        </div>
      </div>
    </template>
    </template>
    <template v-if="showEvaluation && eventSurveyData">
      <div class="session-eval__general-eval">
        <div class="session-eval__general-eval-container">
          <div class="session-eval-list__session">
            <div class="session-eval-list__session_details">
              <span><b>{{
                $t('VMX.evaluation_page_general_congress_eval_title')
              }}</b></span>
            </div>
            <div class="session-eval-list__session_link">
              <template
                v-if="
                  timeCheck(
                    eventSurveyData.EvaluationStart,
                    eventSurveyData.EvaluationEnd
                  ) === 1
                "
              >
                <span>
                  {{ $t('VMX.evaluation_page_eval_available_from') }}
                  {{ displayTime(eventSurveyData.EvaluationStart) }}
                </span>
              </template>
              <template v-else-if="eventSurveyData.EvaluationDone">
                <span>
                  <font-awesome-icon :icon="['fas', 'check']" />
                  {{ $t('VMX.evaluation_page_eval_done') }}
                </span>
              </template>
              <template
                v-else-if="
                  timeCheck(
                    eventSurveyData.EvaluationStart,
                    eventSurveyData.EvaluationEnd
                  ) === 2
                "
              >
                <span>
                  {{ $t('VMX.evaluation_page_eval_not_available') }}
                  {{ displayTime(eventSurveyData.EvaluationEnd) }}
                </span>
              </template>
              <template v-else>
                <b-button @click="goToEval(null)">
                  {{ $t('VMX.evaluation_page_button') }}
                  <font-awesome-icon :icon="['fas', 'arrow-right']" />
                </b-button>
              </template>
            </div>
          </div>
        </div>
      </div>
    </template>
    <div class="session-eval__container" v-if="showEvaluation">
      <div
        class="session-eval__sessions-eval"
        v-for="(session, index) in sessions"
        :key="index"
      >
        <template v-if="session.EvaluationEnabled">
          <div class="session-eval-list__sessions">
            <div class="session-eval-list__session">
              <div class="session-eval-list__session_details">
                <p>
                  <span><b>{{ session.SessionNumber }}</b></span><br />
                  <span><b>{{ session.SessionName }}</b></span>
                </p>
                <span>{{
                  displayTime(
                    session.SessionStartDateTime,
                    session.SessionEndDateTime
                  )
                }}</span>
              </div>
              <div class="session-eval-list__session_link">
                <template
                  v-if="
                    timeCheck(
                      session.EvaluationStart,
                      session.EvaluationEnd
                    ) === 1
                  "
                >
                  <span>
                    {{ $t('VMX.evaluation_page_eval_available_from') }}
                    {{ displayTime(session.EvaluationStart) }}
                  </span>
                </template>
                <template v-else-if="session.EvaluationDone">
                  <span>
                    <font-awesome-icon :icon="['fas', 'check']" />
                    {{ $t('VMX.evaluation_page_eval_done') }}
                  </span>
                </template>
                <template
                  v-else-if="
                    timeCheck(
                      session.EvaluationStart,
                      session.EvaluationEnd
                    ) === 2
                  "
                >
                  {{ $t('VMX.evaluation_page_eval_not_available') }}
                  {{ displayTime(session.EvaluationEnd) }}
                </template>
                <template v-else>
                  <b-button @click="goToEval(session)">
                    {{ $t('VMX.evaluation_page_button') }}
                    <font-awesome-icon :icon="['fas', 'arrow-right']" />
                  </b-button>
                </template>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import dayjs from 'dayjs'
import advancedFormat from 'dayjs/plugin/advancedFormat' // load on demand
import MyCertificates from '../CertificateList/index.vue'
import MyCertificatesLink from '../CertificateList/certButton.vue'
import evaluation from '~/api/evaluation'
import utils from '../../utilities'

dayjs.extend(advancedFormat)

export default {
  components: {
    MyCertificates,
    MyCertificatesLink,
  },
  inject: {
    TrackingUtil: {
      type: Function,
    },
  },
  props: {
    showCertList: {
      type: Boolean,
      default: false,
    },
    showEvaluation: {
      type: Boolean,
      default: true,
    },
    inSurveyPage: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      filter: null,
      sessions: null,
      sortSelected: null,
      eventSurveyData: null,
    }
  },
  computed: {
    ...mapGetters({
      sessionList: 'sessionsForEvaluation/sessions',
      configForKey: 'config/configForKey',
      userId: 'user/userId',
    }),
    evaluationModal() {
      const c = this.configForKey('app_config').configV2
      return 'evaluationModal' in c?.defaultV2
        ? c.defaultV2.evaluationModal
        : false
    },
    results() {
      if (this.sessions && this.sessions.length > 0) {
        return this.sessions.length
      }
      return 0
    },
    sortBy() {
      return {
        status: this.$t('VMX.evaluation_page_sort_by_status'),
        title: this.$t('VMX.evaluation_page_sort_by_title'),
      }
    },
  },
  async mounted() {
    this.sortSelected = 'title'
    if (this.showEvaluation) {
      await this.search()
      this.eventSurveyData = await evaluation.getEventSurvey()
    }
  },
  methods: {
    ...mapActions({
      doSearch: 'sessionsForEvaluation/search',
    }),
    goToEval(session) {
      const id = session?.SessionId
      if(this.evaluationModal && session) {
        window.openEvaluationModal(session)
        return
      }

      if(this.evaluationModal && session === null) {
        window.openEvaluationModal(session)
        return
      }
      if (id ) {
        this.$router
          .push(
            utils.getRouteWithDefaultParams(
              this.inSurveyPage ? 'SurveyPage' : 'MyAreaPage',
              this.inSurveyPage ? null : { module: 'evaluation' },
              { id },
            ),
          )
          .catch((err) => {})
      } else {
        this.$router
          .push(
            utils.getRouteWithDefaultParams(
              this.inSurveyPage ? 'SurveyPage' : 'MyAreaPage',
              this.inSurveyPage ? { eventSurvey } : { module: 'evaluation', eventSurvey },
              { context },
            ),
          )
          .catch((err) => {})
      }
    },
    debounceSearch() {
      setTimeout(() => {
        this.search()
      }, 400)
    },
    async search() {
      this.sessions = await this.doSearch({
        filter: this.filter,
        sortBy: this.sortSelected,
      })
    },
    displayTime(time, endTime) {
      const [backendConfig] = this.configForKey('app_config').config
      let dateFormat = `Do MMMM YYYY, ${utils.timeFormat()}`
      if (backendConfig.programme[0]?.dateformat) {
        dateFormat = `${backendConfig.programme[0]?.dateformat}, ${utils.timeFormat()}`
      }
      if (endTime) {
        return `${dayjs(time).format(dateFormat)} - ${dayjs(endTime).format(`${utils.timeFormat()}`
        )}`
      }
      return dayjs(time).format(dateFormat)
    },
    timeCheck(start, end) {
      const eventTimezone  = utils.eventTimezone()
      let serverTime = this.$store.getters['serverTime/getTime']
      const now = dayjs.tz(dayjs(serverTime), eventTimezone)
      const startTime = dayjs(start)
      const endTime = dayjs(end)
      if (start && startTime >= now) {
        return 1
      }
      if (end && endTime <= now) {
        return 2
      }
      return null
    },
  },
  watch: {
    filter() {
      this.debounceSearch()
    },
    sortSelected() {
      if (this.sessions && this.sessions.length > 1) {
        this.search()
      }
    },
  },
}
</script>

<style lang="scss">
.session-eval__text-box {
  background: #fff;
  padding: 1rem;
}
.session-eval__container {
  display: flex;
  flex-direction: column;
  gap: .5rem;
}
.vmx__evaluation-page__subheading {
  margin: 0;
}
.session-eval__general-eval-container {
  background: #fff;
  padding: 1rem;
}
.session-eval-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  .session-eval-list__sessions {
    padding: 1rem;
    background: #fff;
    display: flex;
    justify-content: space-between;
  }
  .session-eval-list__session {
    display: flex;
    flex-wrap: wrap;
    flex: 0 1 100%;
    align-items: center;

  }
  @media(max-width: 768px) {
    .session-eval-list__session {
      flex-direction: column;
      align-items: flex-start;
      gap: .5rem;
      .session-eval-list__session_link {
        margin: 0;
      }
    }
  }
  .session-eval-list__session_link {
    margin-left: auto;
    button,
    button:active {
      background-color: var(--primary-industry) !important;
    }
    span {
      color: var(--primary-industry) !important;
    }
  }
  .session-eval__sort-by {
    @media (min-width: 375px) {
      text-align: right;
    }
    .session-eval__sort-by-dropdown {
      @media (min-width: 375px) {
        width: 60%;
      }
      @media (min-width: 768px) {
        width: 30%;
      }
    }
  }
}
</style>
